import React from 'react';
import * as Sentry from '@sentry/react';
import { useRouteError, useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import InboxIcon from '@mui/icons-material/Inbox';
import Typography from '@mui/material/Typography';

import BackgroundImage from '@/operator/components/general/BackgroundImage';
import GoBackText from '@/operator/components/general/GoBackText';
import { StyledTwoScreensWrapper } from '@/operator/components/modules/AuthPage/Styles';
import { MessageWithTipMui } from '@/operator/components/modules/AuthPage/setup/MessageWithTipMui';
import { publicPath } from '@/operator/utils/env/urlStrings';

type Props = {
    message?: string;
};

const ErrorPage: React.FC<Props> = ({ message }) => {
    const error = useRouteError() as Error;
    const { t } = useTranslation();
    const [searchParams] = useSearchParams();

    React.useEffect(() => {
        Sentry.captureException(error);
    }, [error]);

    return (
        <StyledTwoScreensWrapper>
            <MessageWithTipMui
                Icon={InboxIcon}
                headlineVariant="h1"
                iconDescription={t('ErrorPage.Content.IconDescription')}
                headline={t('ErrorPage.Content.Header')}
                description={
                    <>
                        <Typography
                            variant="body1"
                            style={{
                                color: '#5B5B5B',
                                marginBottom: '35px',
                            }}
                        >
                            {message ||
                                searchParams.get('error') ||
                                t('ErrorPage.Content.Description')}
                        </Typography>
                        <GoBackText value={t('ErrorPage.Content.BackButton')} />
                    </>
                }
            />

            <BackgroundImage
                src={`${publicPath}/assets/images/background/ErrorPage.svg`}
            />
        </StyledTwoScreensWrapper>
    );
};

export default ErrorPage;
